// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.links[data-v-796b241d]{margin-top:1em}.links[data-v-796b241d] .avatar{padding:0 .5em}div.button-grid[data-v-796b241d]{display:flex;gap:1em}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
